import { useState } from 'react'
import { Modal, Form, Select, Input, DatePicker } from 'antd'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { debounce, isEmpty, trim } from 'lodash'
import moment from 'moment'
import { useStore } from '../../hooks'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { showMessageError } from 'src/helpers/functions'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

const Create = observer((props: any) => {
   const { t } = useTranslation()
   const { visible, onOk, onCancel } = props
   const ApiKeyStore = useStore('ApiKeyStore')
   const UserStore = useStore('UserStore')
   const [form] = Form.useForm()
   const [loading, setLoading] = useState(false)

   const creators = UserStore.listCreator?.rows || []
   const designers = UserStore.listDesigner?.rows || []

   const onFinish = async (values: any) => {
      if (loading) return
      setLoading(true)
      try {
         const expiresAt = values?.expiresAt ? moment(values.expiresAt).toISOString() : null
         const apiKey = await ApiKeyStore.createApiKey(values?.accountId, trim(values?.name) || '', expiresAt)
         if (apiKey) {
            form.resetFields()
            onOk(apiKey)
         }
      } catch (error) {
         showMessageError('Tạo API key thất bại')
      } finally {
         setLoading(false)
      }
   }

   const renderOptions = (list: any[]) =>
      list.map((item: any) => (
         <Select.Option key={item.id} value={item.id}>
            {`${item.name || item.email} - ${item.email} (#${item.id})`}
         </Select.Option>
      ))

   return (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title={'Tạo API key'}
         okText={t(GLOBAL_CLIENT.create)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={onCancel}
         onOk={form.submit}
         confirmLoading={loading}
      >
         <Form {...formItemLayout} form={form} name="createApiKey" onFinish={debounce(onFinish, 400)} scrollToFirstError>
            <Form.Item
               name="accountId"
               label={'Tài khoản'}
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng chọn tài khoản được cấp key'
                  }
               ]}
            >
               <Select
                  size="large"
                  showSearch
                  placeholder={'Chọn tài khoản'}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                     String(option?.children ?? '')
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  }
               >
                  {!isEmpty(creators) && (
                     <Select.OptGroup label="Creator">{renderOptions(creators)}</Select.OptGroup>
                  )}
                  {!isEmpty(designers) && (
                     <Select.OptGroup label="Designer">{renderOptions(designers)}</Select.OptGroup>
                  )}
               </Select>
            </Form.Item>

            <Form.Item name="name" label={'Tên gợi nhớ'}>
               <Input size="large" maxLength={100} placeholder={'VD: Key tích hợp hệ thống ABC'} />
            </Form.Item>

            <Form.Item
               name="expiresAt"
               label={'Ngày hết hạn'}
               extra={'Để trống nếu muốn key không bao giờ hết hạn'}
            >
               <DatePicker
                  size="large"
                  style={{ width: '100%' }}
                  showTime
                  format="DD/MM/YYYY HH:mm"
                  placeholder={'Chọn ngày hết hạn'}
                  disabledDate={(current) => current && current < moment().startOf('day')}
               />
            </Form.Item>
         </Form>
      </Modal>
   )
})

export default Create
